import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../api.service';
import { CommonService } from '../../shared/common.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  @Output() userAddedEvent = new EventEmitter<void>();
  @Output() closeFormEvent = new EventEmitter<void>();

  userForm: FormGroup;
  designations: string[] = []; // Array to hold the designations
  emailError: string | null = null;
  message: string;
  errorMessage: string = '';

  constructor(private fb: FormBuilder, private apiService: ApiService, private commonService: CommonService) {}

  ngOnInit() {
    this.userForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      email: ['', [Validators.required, Validators.email]],
      designation: ['', Validators.required]
      // Removed unnecessary fields: site_location, site_city, site_state, site_country, site_address
    });
    this.loadDesignations(); // Load designations on component init
    // Removed unnecessary API calls: loadCities(), loadSiteLocations(), loadStates()
  }

  get f() {
    return this.userForm.controls;
  }

  private loadDesignations(): void {
    this.apiService.getDesignations().subscribe(response => {
      this.designations = response.map((item: any) => item.designation); // Extract only the designation property
    });
  }
  


  onSubmit() {
    console.log('Form submitted!');
    console.log('Form valid:', this.userForm.valid);
    console.log('Form value:', this.userForm.value);
    console.log('Form errors:', this.userForm.errors);
    
    if (this.userForm.valid) {
      // console.log('Calling API with data:', this.userForm.value);
      let userData = this.userForm.value;
      userData.created_by = this.commonService.getUserData().id;
      
      console.log('User Data: ', userData);

      this.apiService.addUser(userData).subscribe(
        response => {
          console.log('API Response:', response);
          alert('User added successfully');
          this.userForm.reset();
          this.userAddedEvent.emit();
          this.closeFormEvent.emit();
        },
        error => {
          console.log('API Error:', error);
          this.emailError = null;
          
          // Extract error message from the response
          if (error.error && typeof error.error === 'object' && error.error.message) {
            this.errorMessage = error.error.message; // Use backend error message
          } else if (error instanceof Error) {
            this.errorMessage = error.message;
          } else if (typeof error === 'string') {
            this.errorMessage = error;
          } else {
            this.errorMessage = 'An unexpected error occurred';
          }
          
          console.log('Error message:', this.errorMessage);
          
          // Show error alert
          alert(this.errorMessage);
        }
      );
    } else {
      console.log('Form is invalid, marking all fields as touched');
      console.log('Form control errors:', {
        first_name: this.f.first_name.errors,
        last_name: this.f.last_name.errors,
        mobile: this.f.mobile.errors,
        email: this.f.email.errors,
        designation: this.f.designation.errors
      });
      this.userForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.userForm.reset();
    this.closeFormEvent.emit();
  }
}
